<template>
  <secondary-nav />
  <div class="home">
    <h2>Nyheter</h2>
    <News
    imgLeft
    publiced="2023-12-11"
    title="Anmälan öppen"
    newsImg="swimmers-2.jpg"
    externalLink="https://mittlopp.se/Anmalan/Arrangemangsgrupp/KQBZIHUGFEJASCYHSZ"
    linkText="Till anmälan (öppnas i nytt fönster)"
    newsText="Anmälan till 2024 års Säter Triathlon är nu öppen.">
    </News>
    <News
    publiced="2023-12-02"
    title="SM/RM på Olympisk distans"
    newsImg="group.png"
    externalLink="https://www.svensktriathlon.org/ovriga-sidor/nyheter/nyheter/2023-12-01-svenska-triathloncupen-2024-samt-sm-rm-pa-olympisk-distans"
    linkText="Mer information"
    newsText="Nu står det klart att Säter får möjligheten att arrangera SM och RM på Olympisk distans 2024. Mer information finner ni under länken nedan">
    </News>
    <News
    publiced="2023-07-10"
    title="Resultat 2023"
    newsImg="wheels.jpg"
    imgLeft
    newsText="Preliminära resultat för årets tävling finns nu publicerade. Stort tack till alla tävlande och alla funktionärer för era insatser!">
    <router-link to="/results">Resultat</router-link>
    </News>

    <!-- <News
    publiced="2023-07-04"
    title="Pre-race info"
    newsImg="bikes.jpg"
    newsText="Pre-race info för Supersprint och Olympisk och sprint motion finnt nu ute. Hittas under fliken deltagare"
    imgLeft
    />
    <News
    publiced="2023-06-25"
    title="PM 2023"
    newsImg="Satertriathlon_logo_vit.jpg"
    newsText="PM för årets tävling finns nu publicerad. Ni hittar det genom att klicka på fliken 'Deltagare' i menyn"
    />
    <News
    publiced="2023-04-25"
    title="Kartor"
    newsImg="Satertriathlon_logo_vit.jpg"
    newsText="Nu finns kartor och preliminära starttider ute. Ni hittar dom under fliken 'deltagare'"
    imgLeft
    />
    <News
    publiced="2023-03-20"
    newsImg="Satertriathlon_logo_vit.jpg"
    newsText="Upplägget för supersprinten kommer att göras om enligt önskemål från aktiva efter förra årets tävling, exakta upplägget inte klargjort än, information kommer så snart allt är klart. Starttiderna kan komma att justeras när formatet är klarlagt"
    />
    <News
    publiced="2023-01-22"
    newsImg="bike.jpg"
    newsText='Inbjudan till 2023 års tävling finns nu publicerad. Ni hittar den under fliken "deltagare" i menyn  '
    imgLeft /> -->

  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";
import News from "@/components/news.vue";
import SecondaryNav from "@/components/secondaryNav.vue"

export default {
  name: "Home",
  components: {
    // HelloWorld,
    News,
    SecondaryNav
  },
};
</script>
